module.exports = __webpack_public_path__ + "img/forestDetailBio.eeb58373.svg";